import React, { useState, useEffect, useMemo } from "react";
import classes from "./Banner.module.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FeatureCard from "./FeatureCard/FeatureCard";
import { useSelector } from "react-redux";
import { getAllOffers } from "../../../Store/actions/BannerAction";
import OfferCard from "../../../Components/Card/BookCard/OfferCard";
import useScreenSize from "../../../Hooks/UseScreenSize";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

function Banner() {
  const history = useHistory();
  const bannerData = useSelector((state) => state.banners?.banners);
  const { isMediumScreen } = useScreenSize();
  const [offers, setOffers] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  
  // Fetch offers only once when component mounts
  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const res = await getAllOffers();
        if (res?.data?.success) {
          const filteredData = res.data?.data?.filter(
            (offer) => offer?.isDisabled === false
          );
          setOffers(filteredData);
        }
      } catch (error) {
        console.error("Error fetching offers:", error);
      }
    };
    
    fetchOffers();
  }, []);

  // Carousel auto-rotation with optimized interval management
  useEffect(() => {
  let interval;
  
  if (bannerData?.length > 1) {
    interval = setInterval(() => {
      setCurrentIndex(prevIndex => {
        // If at last slide, reset to first without animation
        if (prevIndex === bannerData.length - 1) {
          // Temporarily disable transition
          const wrapper = document.querySelector(`.${classes.carouselWrapper}`);
          if (wrapper) {
            wrapper.style.transition = 'none';
          }
          
          // Reset to first slide
          setTimeout(() => {
            if (wrapper) {
              wrapper.style.transition = '';
            }
          }, 50);
          
          return 0;
        }
        // Normal slide progression
        return prevIndex + 1;
      });
    }, 5000);
  }
  
  return () => {
    if (interval) clearInterval(interval);
  };
}, [bannerData]);

  // Memoize slider settings to prevent unnecessary re-renders
  const settingsRight = useMemo(() => ({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    cssEase: "linear",
    slidesToScroll: 1,
    arrows: false,
    lazyLoad: "progressive"
  }), []);

  return (
    <div className={classes.main_banner}>
      
      {!isMediumScreen && (
        <div
          className={`${classes.bannersContainer} ${
            offers.length === 0 ? classes.singleBanner : ""
          }`}
        >
          <div className={classes.leftBanner}>
            {bannerData && bannerData.length > 0 && (
              <div
                className={classes.carouselWrapper}
                style={{ transform: `translateX(-${currentIndex * 100}%)` }}
              >
                {bannerData.map((data, index) => (
                  <div key={index} className={classes.carousel}>
                    <FeatureCard
                      image={data?.imageUrl}
                      title={data?.title}
                      description={data?.description}
                      altText={data?.altText || "Banner image"}
                      btnText={"Explore Our Best seller"}
                      history={history}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
          
          {offers?.length > 0 && (
            <div className={classes.rightBanner}>
              <div className={classes.top_text}>
                <h2>Limited Time Offers</h2>
              </div>
              <div className={classes.imageContainerRight}>
                <Slider {...settingsRight} className={classes.carousel}>
                  {offers.map((data, index) => (
                    <div key={index}>
                      <OfferCard
                        key={index}
                        offerTitle={data?.offerTitle}
                        image={data.image}
                        title={"Coupon Code"}
                        couponCode={data?.couponCode}
                      />
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          )}
        </div>
      )}

      {isMediumScreen && (
          <div className={classes.imageSection}>
            {offers?.length > 0 ? (
              <div className={classes.rightBanner}>
                <div className={classes.imageContainerRight}>
                  <Slider {...settingsRight}>
                    {offers.map((data, index) => (
                      <div key={index}>
                        <OfferCard
                          key={index}
                          offerTitle={data?.offerTitle}
                          image={data.image}
                          title={"Coupon Code"}
                          couponCode={data?.couponCode}
                        />
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            ) : (
            <>
              {(bannerData && bannerData.length > 0) ? (
                <div className={classes.leftBanner}>
                  <div
                    className={classes.carouselWrapper}
                    style={{ transform: `translateX(-${currentIndex * 100}%)` }}
                  >
                    {bannerData.map((data, index) => (
                      <div key={index} className={classes.carousel}>
                        <FeatureCard
                          image={data?.imageUrl}
                          title={data?.title}
                          description={data?.description}
                          altText={data?.altText || "Banner image"}
                          btnText={"Explore Our Best seller"}
                          history={history}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className={classes.leftBanner}>
                <div
                  className={classes.carouselWrapper}
                  style={{ transform: `translateX(-${currentIndex * 100}%)` }}
                >
                    <div className={classes.carousel}>
                      <FeatureCard
                        image={""}
                        title={""}
                        description={""}
                        altText={"Banner image"}
                        btnText={"Explore our collection"}
                        history={history}
                      />
                    </div>
                </div>
              </div>
              )}
              </>
            )}
          </div>
      )}

      </div>
  );
}

export default React.memo(Banner);